import { Http } from '@mygpt/app/http';
import type { RobotTag, RobotTagPayload } from '@mygpt/types/tag';

/**
 * Get all robot tags (admin only)
 * @returns Robot tag list
 */
export const getRobotTags = () => {
  const { get } = Http.use();
  return get<RobotTag[]>('/robot-tags');
};

/**
 * Create a new robot tag (admin only)
 * @param payload Tag data
 * @returns Created tag
 */
export const createRobotTag = (payload: RobotTagPayload) => {
  const { post } = Http.use();
  return post<RobotTag>('/robot-tags', payload);
};

/**
 * Update a robot tag (admin only)
 * @param tagId Tag ID
 * @param payload Tag data
 * @returns Updated tag
 */
export const updateRobotTag = (tagId: string, payload: RobotTagPayload) => {
  const { put } = Http.use();
  return put<RobotTag>(`/robot-tags/${tagId}`, payload);
};

/**
 * Delete a robot tag (admin only)
 * @param tagId Tag ID
 * @returns
 */
export const deleteRobotTag = (tagId: string) => {
  const { delete: del } = Http.use();
  return del(`/robot-tags/${tagId}`);
};

/**
 * Get tags for a specific robot
 * @param robotId Robot ID
 * @returns Robot tags
 */
export const getRobotTagsById = (robotId: string) => {
  const { get } = Http.use();
  return get<RobotTag[]>(`/robots/${robotId}/tags`);
};

/**
 * Set tags for a specific robot (admin/owner only)
 * @param robotId Robot ID
 * @param tagIds Tag IDs
 * @returns
 */
export const setRobotTags = (robotId: string, tagIds: string[]) => {
  const { put } = Http.use();
  // Filter out empty strings and duplicates to prevent 422 errors
  const cleanedTagIds = Array.from(new Set(tagIds.filter((id) => id && id.trim().length > 0)));
  return put(`/robots/${robotId}/tags`, { tag_ids: cleanedTagIds });
};
